import Glide from '@glidejs/glide';
import testimonials from '../../data/testimonials';

const TestimonialsSlider = () => {
  const tmWrapper = document.querySelector('.section-testimonials__wrapper');
  const testimonialClones = [...document.querySelectorAll('.testimonial-clone')];
  const setActiveSlide = (index) => {
    testimonialClones.forEach((el, i) => {
      const clone = el;
      clone.classList.remove('testimonial-clone--active');
      clone.setAttribute('data-text', `${testimonials[i].body.substring(0, 60)}...`);
    });
    testimonialClones[index].classList.add('testimonial-clone--active');
  };

  const slider = new Glide('.testimonials', {
    perView: 1,
  });

  slider.on('mount.before', () => {
    tmWrapper.classList.add('testimonials--show');

    setActiveSlide(slider.index);
  });

  slider.on('mount.after', () => {
    setTimeout(() => {
      tmWrapper.classList.add('testimonials--loaded');
    }, 2000);
  });

  slider.on('run.after', () => {
    setActiveSlide(slider.index);
  });

  slider.mount();
};

export default TestimonialsSlider;
